import styled, { css } from 'styled-components';
import { Button as BoltButton } from '@sainsburys-tech/bolt';
var Wrapper = styled.div.withConfig({
  displayName: "Inputstyles__Wrapper",
  componentId: "sc-14wbi02-0"
})(["display:flex;flex-direction:column;width:", ";margin-bottom:", ";"], function (props) {
  return props.wrapperWidth || '100%';
}, function (props) {
  return "".concat(props.marginBottom, "px");
});
var Label = styled.label.withConfig({
  displayName: "Inputstyles__Label",
  componentId: "sc-14wbi02-1"
})(["font-weight:", ";margin-bottom:", ";pointer-events:none;"], function (props) {
  return props.theme.font.weight.bold;
}, function (props) {
  return props.hasSecondLine ? '7px' : '10px';
});
var OptionalLabel = styled.span.withConfig({
  displayName: "Inputstyles__OptionalLabel",
  componentId: "sc-14wbi02-2"
})(["color:", ";margin-left:8px;font-size:", ";display:inline-block;text-transform:capitalize;"], function (props) {
  return props.theme.color.monochrome.base;
}, function (props) {
  return props.theme.font.size.caption;
});
var ErrorMessage = styled.span.withConfig({
  displayName: "Inputstyles__ErrorMessage",
  componentId: "sc-14wbi02-3"
})(["font-size:", ";font-weight:", ";color:", ";margin-bottom:7px;"], function (props) {
  return props.theme.font.size.caption;
}, function (props) {
  return props.theme.font.weight.bold;
}, function (props) {
  return props.theme.color.semantic.error.base;
});
var HintRow = styled.div.withConfig({
  displayName: "Inputstyles__HintRow",
  componentId: "sc-14wbi02-4"
})(["font-size:", ";line-height:normal;margin-bottom:7px;"], function (props) {
  return props.theme.font.size.caption;
});
var Hint = styled.span.withConfig({
  displayName: "Inputstyles__Hint",
  componentId: "sc-14wbi02-5"
})(["font-weight:", ";color:", ";margin-right:4px;"], function (props) {
  return props.theme.font.weight.regular;
}, function (props) {
  return props.theme.color.monochrome.dark;
});
var Link = styled.a.withConfig({
  displayName: "Inputstyles__Link",
  componentId: "sc-14wbi02-6"
})(["font-weight:", ";color:", ";text-decoration:underline;white-space:nowrap;"], function (props) {
  return props.theme.font.weight.bold;
}, function (props) {
  return props.theme.color.palette['brand-1'];
});
var InputRow = styled.div.withConfig({
  displayName: "Inputstyles__InputRow",
  componentId: "sc-14wbi02-7"
})(["position:relative;height:100%;max-width:", ";flex:1;-ms-flex:auto;", ""], function (props) {
  return props.maxWidth;
}, function (props) {
  return props.hasCustomButton && css(["display:flex;"]);
});
var Input = styled.input.withConfig({
  displayName: "Inputstyles__Input",
  componentId: "sc-14wbi02-8"
})(["width:100%;margin:1px;padding:12px 17px 13px 15px;padding-left:", ";padding-right:", ";font-family:", ";font-size:", ";color:", ";background-color:", ";border:", ";border-radius:", ";&::placeholder{color:", ";}", " ", " ", " &:-webkit-autofill,&:-webkit-autofill:hover,&:-webkit-autofill:focus{-webkit-box-shadow:0 0 0 1000px ", " inset !important;}", " ", " ", " ", ""], function (props) {
  return props.leftIcon ? "calc(".concat(props.leftIconWidth, " + 24px)") : '15px';
}, function (props) {
  return props.rightIcon ? "calc(".concat(props.rightIconWidth, " + 24px)") : '15px';
}, function (props) {
  return props.theme.font.family.brand;
}, function (props) {
  return props.theme.font.size.base;
}, function (props) {
  return props.theme.color.monochrome.dark;
}, function (props) {
  return props.theme.color.monochrome.white;
}, function (props) {
  return "".concat(props.theme.size.border.width.sm, " solid ").concat(props.theme.color.monochrome.base);
}, function (props) {
  return props.theme.size.border.radius.lg;
}, function (props) {
  return props.theme.color.monochrome.base;
}, function (props) {
  return props.error && css(["border-width:", ";border-radius:", ";border-color:", ";color:", ";"], props.theme.size.border.width.md, props.theme.size.border.radius.lg, props.theme.color.semantic.error.base, props.theme.color.monochrome.dark);
}, function (props) {
  return props.disabled && css(["opacity:0.35;cursor:not-allowed;background-color:", ";border-color:", ";color:", ";"], props.theme.color.monochrome.white, props.theme.color.monochrome.base, props.theme.color.monochrome.base);
}, function (props) {
  return !props.error && !props.disabled && css(["&:hover,&:active,&:focus,", ":hover &{border-color:", ";border-width:", ";border-radius:", ";margin:0;}&:active,&:focus{border-color:", ";color:", ";outline:none;}"], InputRow, props.theme.color.monochrome.dark, props.theme.size.border.width.md, props.theme.size.border.radius.lg, props.theme.color.palette['brand-1-dark'], props.theme.color.monochrome.darker);
}, function (props) {
  return props.theme.color.monochrome.white;
}, function (props) {
  return props.type === 'search' ? css(["&::-webkit-search-decoration,&::-webkit-search-cancel-button,&::-webkit-search-results-button,&::-webkit-search-results-decoration{display:none;}"]) : null;
}, function (props) {
  return props.type === 'search' || props.type === 'text' ? css(["&::-ms-clear,&::-ms-reveal{display:none;width:0;height:0;}"]) : null;
}, function (props) {
  return props.as === 'textarea' && css(["resize:none;overflow:hidden;padding:11px 19px;"]);
}, function (props) {
  return props.hasCustomButton && css(["margin:1px 0 1px 1px;border-right:none;border-radius:", " 0 0 ", ";&:hover,&:active,&:focus,", ":hover &{border-radius:", " 0 0 ", ";}"], props.theme.size.border.radius.lg, props.theme.size.border.radius.lg, InputRow, props.theme.size.border.radius.lg, props.theme.size.border.radius.lg);
});
var IconContainer = styled.div.withConfig({
  displayName: "Inputstyles__IconContainer",
  componentId: "sc-14wbi02-9"
})(["position:absolute;top:50%;left:", ";right:", ";transform:translate(0,-50%);pointer-events:none;"], function (props) {
  return props.position === 'left' ? '15px' : 'auto';
}, function (props) {
  return props.position === 'left' ? 'auto' : '15px';
});
var Button = styled(IconContainer).attrs({
  as: 'button'
}).withConfig({
  displayName: "Inputstyles__Button",
  componentId: "sc-14wbi02-10"
})(["background:none;border:none;padding:0;pointer-events:all;"]);
var PasswordToggle = styled.button.withConfig({
  displayName: "Inputstyles__PasswordToggle",
  componentId: "sc-14wbi02-11"
})(["position:absolute;margin:1px 0;top:0;bottom:0;right:-1px;width:70px;background-color:", ";border:transparent;border-top-right-radius:", ";border-bottom-right-radius:", ";font-family:", ";font-size:", ";font-weight:", ";color:", ";&:hover,&:active,&:focus{background-color:", ";}", ":hover &&{margin:", ";border-top-right-radius:", ";border-bottom-right-radius:", ";}", ""], function (props) {
  return props.theme.color.palette['brand-1'];
}, function (props) {
  return props.theme.size.border.width.sm;
}, function (props) {
  return props.theme.size.border.width.sm;
}, function (props) {
  return props.theme.font.family.brand;
}, function (props) {
  return props.theme.font.size.base;
}, function (props) {
  return props.theme.font.weight.bold;
}, function (props) {
  return props.theme.color.monochrome.lighter;
}, function (props) {
  return props.theme.color.palette['brand-1-dark'];
}, InputRow, function (props) {
  return props.error ? '1px 0' : '0';
}, function (props) {
  return props.theme.size.border.width.sm;
}, function (props) {
  return props.theme.size.border.width.sm;
}, function (props) {
  return props.isInputFocused && css(["border-top-right-radius:", ";border-bottom-right-radius:", ";margin:", ";"], props.theme.size.border.width.md, props.theme.size.border.width.md, props.error ? '1px 0' : '0');
});
var CustomButton = styled(BoltButton).withConfig({
  displayName: "Inputstyles__CustomButton",
  componentId: "sc-14wbi02-12"
})(["margin:1px 1px 1px 0;border-radius:", ";flex-shrink:0;", ":hover &{margin:", ";}", ""], function (props) {
  return "0 ".concat(props.theme.size.border.width.lg, " ").concat(props.theme.size.border.width.lg, " 0");
}, InputRow, function (props) {
  return props.error ? '1px' : '0';
}, function (props) {
  return props.isInputFocused && css(["margin:", ";"], props.error ? '1px' : '0');
});
var CharCount = styled.span.withConfig({
  displayName: "Inputstyles__CharCount",
  componentId: "sc-14wbi02-13"
})(["font-size:", ";font-weight:", ";color:", ";margin:0 0 10px;max-width:", ";"], function (props) {
  return props.theme.font.size.caption;
}, function (props) {
  return props.theme.font.weight.regular;
}, function (props) {
  return props.theme.color.monochrome.dark;
}, function (props) {
  return props.maxWidth;
});
export { Wrapper, ErrorMessage, HintRow, Hint, Link, Label, OptionalLabel, InputRow, Input, IconContainer, Button, PasswordToggle, CustomButton, CharCount };